import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AccountDropdown from './account-dropdown'
import { TomNewPicturesIndicator } from './components/tom-new-pictures-indicator'
import GlobalSearch from './global-search'
import DashboardMapSwitcher from './components/dashboard-map-switcher'
import { useLocation } from 'react-router-dom'
// import { useSelector } from 'react-redux'
import { changeDashboardType } from './actions'
import { DASHBOARD_MAP_SWITCHER_OPTIONS } from './constants'
// import { getDashboardPreferrence } from '../dashboard/api/dashboard-api'
// import { Tooltip } from './components/common'
import { LOCAL_DATA_KEY } from './constants'
import Icon from '@mdi/react'
import { mdiLogout } from '@mdi/js'
import { IconButton } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { reloadUser } from './actions'
import { LogOutIcon } from 'lucide-react'

/* import Search from './search' */

const useStyles = makeStyles(theme => ({
    headerWrapper: {
        height: '100%',
        // padding: '50px 32px 50px 32px',
        paddingRight: 16,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: '20px'
    },
    searchSection: {
        alignSelf: 'flex-start',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
        // borderRight: theme.border
    },
    searchCell: {
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: 0
    },
    accountSection: {
        alignSelf: 'flex-end',
        // width: 80,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&& > button': {
            marginRight: 16
        }
    },
    dashboardTypeSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    impersonationMode: {
        color: theme.quaternary,
        position: 'absolute',
        left: '7%',
        top: '23px',
        zIndex: 1000
    }
}))

export default function Header() {
    const classes = useStyles()
    const location = useLocation()
    const dispatch = useDispatch()
    // const { locale } = useSelector((state) => state.main)

    useEffect(() => {
        if (location.pathname !== '/dashboard') {
            dispatch(
                changeDashboardType(
                    DASHBOARD_MAP_SWITCHER_OPTIONS.mapView.value
                )
            )
        }
    }, [location, dispatch])

    // useEffect(() => {
    //     const initializeDashboardType = async () => {
    //         const dashboardType = await getDashboardPreferrence()

    //         if (!dashboardType.preferred_dashboard_view) {
    //             dispatch(
    //                 changeDashboardType(
    //                     DASHBOARD_MAP_SWITCHER_OPTIONS.dashboard.value
    //                 )
    //             )
    //         } else {
    //             dispatch(
    //                 changeDashboardType(dashboardType.preferred_dashboard_view)
    //             )
    //         }
    //     }

    //     initializeDashboardType()
    // }, [dispatch])

    const isDashboardRoute = location.pathname === '/dashboard'
    const { locale, i, user } = useSelector(state => state.main)

    const returnToSuperAdmin = () => {
        if (i && i.superAdminId) {
            dispatch(reloadUser(true))
        }
    }

    return (
        <div className={classes.headerWrapper}>
            <div className={classes.searchSection}>
                <GlobalSearch />
            </div>
            {isDashboardRoute && (
                <div className={classes.dashboardTypeSection}>
                    {/* <Tooltip
                        enterDelay={1000}
                        hover
                        placement="bottom"
                        text={locale.dashboard.switcherHoverTooltip}>
                    </Tooltip> */}
                    <DashboardMapSwitcher />
                </div>
            )}
            <div className={classes.searchSection}>{/* <Search/> */}</div>
            <div className={classes.accountSection}>
                {i?.superAdminId && i.superAdminId !== user?.id && (
                    <div className={classes.impersonationMode}>
                        {locale.dashboard.loggedInAs} {user?.name}
                        <IconButton
                            size="small"
                            style={{ marginLeft: 4 }}
                            onClick={returnToSuperAdmin}
                        >
                            <LogOutIcon size={18} />
                        </IconButton>
                    </div>
                )}
                <TomNewPicturesIndicator />
                <AccountDropdown />
            </div>
        </div>
    )
}
